import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';

interface EditLabelToolbarProps {
  onDelete: () => void;
  deleteLabel?: string;
}

export function EditLabelToolbar({ onDelete, deleteLabel = 'Delete label' }: EditLabelToolbarProps) {
  return (
    <div className="label-editor-form__toolbar">
      <button
        type="button"
        aria-label={deleteLabel}
        className="label-editor-form__delete"
        onClick={onDelete}
      >
        <FontAwesomeIcon icon={faTrash} />
      </button>
    </div>
  );
}

export default EditLabelToolbar;